import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Translate from 'translate';

import AsyncTable from 'components/HTMLElements/Table/AsyncTable/';
import ConfigurationService from 'services/ConfigurationService';
import { toggleAlertError, toggleLoading } from 'stores/actions';
import LogDetail from '../../../components/Management/LogDetail';

class Settings extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: {},
      incmsData: [],
      systemData: [],
      logDetailModalOpened: false,
      systemLogDetailModalOpened: false,
    };
    this.logEntity = {};
    this.systemLogEntity = {};
  }

  getIncmsLogs = ( params, cb ) => {
    const { toggleLoading } = this.props;
    this.incmsParams = params;
    toggleLoading( true );

    const apiParams = {
      limit: params.pageSize,
      offset: ( params.page * params.pageSize ),
    };
    apiParams[`filters[originIn]`] = ['incms', 'ims'];
    if( params.sorted.length ) apiParams[`sortby[${params.sorted[0].id}]`] = params.sorted[0].desc ? 'DESC' : 'ASC';
    else apiParams[`sortby[createdAt]`] = 'DESC';

    ConfigurationService.getLogs( apiParams ).then( ( response ) => {
      if( cb ) return cb( response.errors, response.data );

      toggleLoading( false );

      if( response.data ) {
        this.setState( {
          incmsData: response.data.data || [],
          pages: Math.ceil( response.data.total / params.pageSize ),
          total: response.data.total,
        } );
      }
    } )
  };

  getSystemLogs = ( params ) => {
    const { toggleLoading } = this.props;
    toggleLoading( true );

    const apiParams = {
      limit: params.pageSize,
      offset: ( params.page * params.pageSize ),
    };
    apiParams[`filters[origin]`] = 'system';
    if( params.sorted.length ) apiParams[`sortby[${params.sorted[0].id}]`] = params.sorted[0].desc ? 'DESC' : 'ASC';
    else apiParams[`sortby[createdAt]`] = 'DESC';

    ConfigurationService.getLogs( apiParams ).then( ( response ) => {
      toggleLoading( false );

      if( response.data ) {
        this.setState( {
          systemData: response.data.data || [],
          systemPages: Math.ceil( response.data.total / params.pageSize ),
          systemTotal: response.data.total,
        } );
      }
    } )
  };

  toggleLogDetailModal = ( item ) => {
    this.logEntity = item;
    this.setState( { logDetailModalOpened: !this.state.logDetailModalOpened } )
  };

  toggleSystemLogDetailModal = ( item ) => {
    this.systemLogEntity = item;
    this.setState( { systemLogDetailModalOpened: !this.state.systemLogDetailModalOpened } )
  };

  render() {
    const { incmsData, systemData, systemPages, systemTotal, logDetailModalOpened, systemLogDetailModalOpened } = this.state;

    return (
      <div>
        <div className="box box-default">
          <div className="box-header d-flex justify-content-between">
            <span className="text-capitalize"><Translate id="incmsLogs"/></span>
            <button className="btn btn-info ml-2" onClick={() => this.getIncmsLogs(this.incmsParams)}>
              <Translate id="reload"/>
            </button>
          </div>
          <div className="box-body">
            <AsyncTable className="app-table-white"
                        onFetchData={this.getIncmsLogs}
                        rowsText="Logs"
                        {...this.state}
                        data={incmsData}
                        columns={[
                          { Header: <Translate id="action"/>, accessor: 'action', maxWidth: 80 },
                          { Header: <Translate id="url"/>, accessor: 'url' },
                          { Header: <Translate id="statusResponse"/>, accessor: 'statusResponse', maxWidth: 120 },
                          { Header: <Translate id="response"/>, accessor: 'response' },
                          { Header: <Translate id="origin"/>, accessor: 'origin', maxWidth: 80 },
                          {
                            Header: <Translate id="createdAt"/>, accessor: 'createdAt',
                            Cell: props => moment( props.value ).format( 'DD/MM/YYYY hh:mm A' )
                          },
                        ]}
                        getTdProps={( state, rowInfo, column, instance ) => {
                          return {
                            onClick: ( e, handleOriginal ) => {
                              this.toggleLogDetailModal( rowInfo.original );

                              if( handleOriginal ) {
                                handleOriginal()
                              }
                            }
                          }
                        }}/>
          </div>
        </div>

        <LogDetail open={logDetailModalOpened}
                   data={this.logEntity}
                   onClose={this.toggleLogDetailModal}
        />
      </div>
    )
  }
}

const mapStateToProps = ( state ) => ( {
  isLoading: state.settings.isLoading
} );

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( Settings );



// WEBPACK FOOTER //
// ./routes/app/routes/management/settings/index.js